import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['fieldsGroup', 'toggleFieldsButtonWrapper'];
  static values = { visible: Boolean };

  connect() {
    if (!!this.visibleValue) this.revealFields();
  }

  revealFields() {
    this.fieldsGroupTarget.classList.remove('d-none');
    this.toggleFieldsButtonWrapperTarget.classList.add('d-none');
  }
}
